<template>
  <div class="disable-scroll-x">
    <div
      style="
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      "
    >
      <CRow class="ml-5 mr-5" style="width: -webkit-fill-available">
        <Mainlayout></Mainlayout>
        <!-- to hide mobile view -->
        <div class="ml-5 mr-5" style="width: inherit">
          <CRow>
            <div style="width: 100%" class="text-center mt-5">
              <h3 class="mt-5 text-white text-header-banner-48px">
                <b>Your teaching skill worth to share!</b>
              </h3>
            </div>

            <div style="width: 40%" class="float-left d-sm-down-none">
              <div class="top-left mb-3 mt-5">
                <h3 class="mt-2 text-center text-dark-grey">
                  <b>
                    Video class <br />
                    made easy.</b
                  >
                </h3>

                <label class="text-white-subtitle mt-3 text-16px">
                  Earn more money by sharing <br />
                  your online classes on our platform <br />
                  and reaching a larger audience.
                </label>
                <br /><br />
              </div>
            </div>


            <div style="width: 100%" class="float-left d-md-none">
              <div class="top-left mb-3 mt-5">
                <h3 class="mt-2 text-center text-dark-grey" style="font-size:30px">
                  <b>
                    Video class <br />
                    made easy.</b
                  >
                </h3>

                <label class="text-white-subtitle mt-3 text-16px">
                  Earn more money by sharing <br />
                  your online classes on our platform <br />
                  and reaching a larger audience.
                </label>
                <br /><br />
              </div>
            </div>

            <div style="width: 60%" class="float-right">
              <img src="../assets/img/earn.svg" class="mt-5 mr-3 mb-3" />
              <br /><br /><br /><br />
              <br /><br />
              <br /><br />
            </div>

            <div style="clear: both"></div>
          </CRow>
        </div>
      </CRow>
    </div>

    <div class="card-custom-web">
      <CContainer>
        <CCol sm="12">
          <div class="text-center">
            <br />
            <h3 class="text-custom-black text-center mt-5">
              <b>
                Photos may speak a thousand words,<br />
                but videos tell the entire story.</b
              >
            </h3>
            <br />
            <label class="text-center">To begin uploading your videos, simply follow these steps...</label>
            <br /><br />
            <CRow>
                <CCol sm="6">
                    <div class="p-3"> <img src="../assets/img/signup.svg" style="max-width:100%"/></div>
                   
                </CCol>
                <CCol sm="6">
                    <h3 class="header-34px text-left mt-5 ml-3"><b>Register as tutor in our platform</b></h3>
                    <label class="text-left ml-3">As a registered tutor on our platform, you will be entitled to numerous benefits, including the ability to store your videos on our platform.</label>
                </CCol>

                <CCol sm="6">
                    <br />
                    <h3 class="header-34px text-left mt-5"><b>Provide necessary info for smooth uploading</b></h3>
                    <label class="text-left">To ensure a smooth uploading process, be sure to provide your video and all necessary information as described in the form.</label>
                   
                </CCol>
                <CCol sm="6">
                  

                    <div class="p-3"> <img src="../assets/img/edit.svg" style="max-width:100%"/></div>
                </CCol>


                <CCol sm="6">
                    <div class="p-3"> <img src="../assets/img/upload.svg" style="max-width:100%"/></div>
                   
                </CCol>
                <CCol sm="6">
                    <br />
                    <h3 class="header-34px text-left mt-5 ml-3"><b>How monetization works</b></h3>
                    <label class="text-left ml-3">Your videos will be regularly monitored and you will be paid royalties based on the number of views they receive. You can track all of this from your account.</label>
                </CCol>
            </CRow>
          </div>
        </CCol>
      </CContainer>
    </div>

    <Footerlayout></Footerlayout>
  </div>
</template>
    
    
    
    
    <script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import AnimatedNumber from "animated-number-vue";
import backgroundUrl from "../assets/img/bg3.png";

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

import VueAgile from "vue-agile";
Vue.use(VueAgile);

// in component

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import $ from "jquery";

import MenuIcon from "vue-material-design-icons/Menu.vue";
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute(
            "style",
            "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
          );
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute(
          "style",
          "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
        );
      }
    },
  },
});
export default {
  name: "Login",
  components: {
    Carousel3d,
    Slide,
    VueCal,
    MenuIcon,
    agile: VueAgile,
    Mainlayout,
    AnimatedNumber,
    backgroundUrl,
    Footerlayout,
  },
  data() {
    return {
      slides: 5,
      selectedGrade: "SELECT GRADE",
      selectedGradeAll: "SELECT GRADE",
      gradeOptions: [],
      FilteredGrades: [],

      FilteredGradesAll: [],

      counter: "",
      round: "",

      scheduleclass: true,
      others: false,

      isShowPrimary: true,
      isShowSecondary: false,

      SearchQuery: "",
      FilterBySubject: [],
      popular: [],
    };
  },
  created() {
    AOS.init();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.GetAllVideo();
    this.GetListVideoPopular();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {},

  methods: {
    ReloadButton() {
      window.open("https://www.pickiddo.com/home", "_self");
    },

    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },

    GoToLogin() {
      window.open("https://app.pickiddo.com/v3/#/LoginPickiddo");
    },
    GoToPlayVideo() {
      window.open("https://tv.pickiddo.com");
    },
    ApplyFilter: function () {
      var arr = _.orderBy(this.video, ["subjectName"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ subjectName }) =>
          _.some([
            _.includes(!subjectName || subjectName.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );

        this.FilterBySubject = result;
      }
    },
    GetAllVideo() {
      this.$API
        .get(this.$GetAllListVideo, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.video = response.data;
            this.FilterBySubject = this.video;
            this.getPicTeacher(this.FilterBySubject.filePath);
          }
        });
    },
    getPicTeacher(item) {
      return "https://d3us0m7iuwh1d3.cloudfront.net/" + item.filePath;
    },
    GetListVideoBySubject(Id) {
      this.$router.push("MainVideo?videoId=" + Id);
    },
    GetListVideoPopular() {
      this.$API.get(this.$GetListPopular).then((response) => {
        if (response.status == 200 && response.data != null) {
          this.popular = response.data;
          this.getPicPopular(this.popular.filePath);
          this.getPicBanner(this.popular.filePathBanner);
          this.logDuration(this.popular.fileVideo);
        }
      });
    },
    getPicPopular(index) {
      return (
        "https://d3us0m7iuwh1d3.cloudfront.net/" + this.popular[index].filePath
      );
    },
    getPicBanner(index) {
      return (
        "https://d3us0m7iuwh1d3.cloudfront.net/" +
        this.popular[index].filePathBanner
      );
    },
    logDuration(index) {
      durationVideos =
        "https://d3us0m7iuwh1d3.cloudfront.net/" +
        this.popular[index].fileVideo;
      //  this.durationVideo = this.$refs.durationVideos.duration;
      console.log("masuk", this.durationVideo);

      var x = this.$refs.durationVideos.duration;
      return x;
    },
  },
};
</script>
        <<style scoped>
    
    @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
    @import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
        
    .c-header {
      /* background: rgb(23, 77, 124);
      background: linear-gradient(92deg, #174d7c, #1b7682);
      border-bottom: 0.01px solid #1a6783;
      border-bottom: 1px solid #636f83; */
    
      background: transparent;
      border-bottom: 0;
      border-bottom: 0;
      /* color: #fff; */
    }
    .c-app{
      background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      font-family: 'Montserrat', sans-serif;
    }
    body {
      font-family: "Montserrat", sans-serif;
      background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    }
    h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
        margin-bottom: 0.5rem;
        font-weight: 500;
        line-height: 1.2;
        font-family: "Montserrat", sans-serif;
    }
    label
    {
      font-family: "Montserrat", sans-serif;
    }
    
    body nav.onScroll {
      box-shadow: 0 0 10px #aaa;
      background-color: rgb(255, 255, 255);
      font-family: 'Montserrat';
    font-style: normal;
    }
    body nav.onScroll ul li {
      color: #10b761;
    }
    body nav ul {
      margin-left: 3em;
      width: 25%;
      display: flex;
      justify-content: space-between;
    }
    body nav ul li {
      cursor: pointer;
      font-weight: 600;
      list-style-type: none;
      color: white;
    }
    body {
        top: 0 !important;
        font-family: 'Montserrat', sans-serif;
    }
    li{
      font-family: 'Montserrat', sans-serif;
    }
    .centered {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    
  .custom-input-text input[type="text"] ::placeholder {
    color: #fff;
  }
  .custom-input-text input[type="text"]::placeholder {
    color: #fff;
  }

  .card-custom-web {
    left: 0px;
    margin-top: -130px;
    width: 100%;
    background: #f9f9f9;
    -webkit-box-shadow: 0px 4px 20px rgb(0 0 0 / 8%);
    box-shadow: 0px 4px 20px rgb(0 0 0 / 8%);
    border-radius: 150px 0px 0px 0px;
    color: #000;
}
        </style>